import { KeyTextField } from '@prismicio/client';
import staticStyles from './subtitle.module.scss';

interface SubtitleProps {
  subtitle: KeyTextField;
  styles?: string;
  isVisible?: boolean;
}

export const Subtitle = ({ subtitle, styles, isVisible }: SubtitleProps) => {
  return (
    <p
      className={`${styles ?? ''} ${staticStyles.subtitle} ${isVisible ? staticStyles.isVisible : ''}`}
    >
      {subtitle}
    </p>
  );
};
